import { Link } from 'react-router-dom';
import type { Product } from '../../../types/product';
import WishlistButton from '../../../components/base/WishlistButton';

interface RelatedProductsProps {
  products: Product[];
}

export default function RelatedProducts({ products }: RelatedProductsProps) {
  return (
    <div>
      <h2 className="text-xl sm:text-2xl font-serif text-gray-900 mb-5 sm:mb-8">YOU MAY ALSO LIKE</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {products.map((product) => (
          <Link
            key={product.id}
            to={`/product/${product.id}`}
            className="group cursor-pointer"
          >
            <div className="relative bg-[#F1F8E9] rounded-xl overflow-hidden mb-3 sm:mb-4 h-56 sm:h-72 lg:h-80">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              {product.status && (
                <span className="absolute top-3 left-3 px-3 py-1 bg-[#2E7D32] text-white text-xs font-bold tracking-wider rounded-full">
                  {product.status}
                </span>
              )}
              <WishlistButton
                product={{
                  id: product.id,
                  name: product.name,
                  price: product.price,
                  image: product.image,
                  category: product.category,
                }}
                size="sm"
                className="absolute top-3 right-3 z-10 shadow-sm"
              />
            </div>
            <p className="text-xs text-gray-500 tracking-wider mb-1 sm:mb-2 uppercase">{product.category}</p>
            <h3 className="text-sm sm:text-base font-serif text-gray-900 mb-1 sm:mb-2 group-hover:text-[#2E7D32] transition-colors">
              {product.name}
            </h3>
            <p className="text-lg font-serif text-gray-900">
              ${product.price.toFixed(2)}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}
